import React, { useMemo, useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { toast } from 'react-toastify';
import { useGetOverviewTrackingQuery, useToggleOverviewStatusMutation } from '../../../../redux/services/SRC.js';
import TableGrid from "../../../../Components/common/TableGrid";
import { clearSelectedRowsData } from "../../../../redux/features/table/tableSlice";
import { ReactComponent as ArchiveIcon } from "../../../../assets/images/slotplanning/archive_icon.svg";
import { ReactComponent as EyeIcon } from "../../../../assets/images/slotplanning/Eye_Icon 1.svg";
import { CallApi, CommonModal, getTodayDateTime } from '../../../../Components/common/CommonFunctions.js';
import { Container, Row, Col, Modal, Form, Button, Table, Accordion, Badge } from 'react-bootstrap';
import { withRFSToken } from '../../../../Services/axios.js';
import { GETDESTINATION } from '../../../../Utils/conts.js';
import TableFilters from '../../../../Components/common/TableGrid/TableFilters.js';

const Tracking = ({ propData , dropData }) => {

    const [showModal, setShowModal] = useState(false)
    const [modalData, setModalData] = useState({})
    const dispatch = useDispatch();
    const { pageDetails, filters, sortby, tab } = useSelector((state) => state.table);
    const isMounted = useRef(false);
    const fetchFSU = (data) => {
        CallApi({
            endPoint: 'v2/service-recovery/tracking-details',
            payload: { trucking_id: data.trucking_id },
            onSuccess: (res) => {
                if (res.data.response_code === 200) {
                    const innerData = res.data.response_data;
                    setModalData(innerData)
                    setShowModal(true)
                } else {
                    toast.error(res.data.response_msg)
                }
            },
            onError: (msg) => toast.error(msg)
        });
    }
    const buildFilterParams = (filtersObj) => {
        const params = {};
        Object.entries(filtersObj).forEach(([key, value]) => {
            if (value === undefined || value === null || value === "" || (Array.isArray(value) && value.length === 0)) {
                return;
            }
            if (Array.isArray(value)) {
                params[key] = JSON.stringify(value);
            } else {
                params[key] = value;
            }
        });
        if (Object.keys(params).length > 0) {
            params.is_filter = true;
        }
        return params;
    };

    const awbParams = useMemo(() => {
        try {
            const detailsTitle = localStorage.getItem('DetailsTitle');
            if (detailsTitle) {
                const dashIndex = detailsTitle.indexOf('-');
                if (dashIndex !== -1) {
                    return {
                        master_airway_bill_prefix: detailsTitle.substring(0, dashIndex).trim(),
                        master_airway_bill_no: detailsTitle.substring(dashIndex + 1).trim(),
                    };
                }
            }
        } catch (e) {
            console.error('Failed to parse DetailsTitle from localStorage', e);
        }
        return {};
    }, []);

    const queryParams = useMemo(() => {
        const filterParams = buildFilterParams(filters);

        const params = {
            ...filterParams,
            ...awbParams,
            pagenum: pageDetails.pagenum,
            pagesize: pageDetails.pagesize,
        };

        if (sortby?.sortdatafield) {
            params.sortdatafield = sortby.sortdatafield;
            params.sortorder = sortby.sortorder;
        }

        if (tab?.value && tab.key) {
            params[tab.key] = tab.value;
        }

        return params;
    }, [filters, pageDetails, sortby, tab, awbParams]);

    const { data: myData, isFetching, refetch } = useGetOverviewTrackingQuery(queryParams, {
        skip: pageDetails.pagesize === 0 || !awbParams.master_airway_bill_prefix,
        refetchOnMountOrArgChange: true,
    });

    const [toggleOverviewStatus] = useToggleOverviewStatusMutation();

    const handleArchive = async (rows) => {
        try {
            const ids = rows.map((r) => r.service_recovery_id);
            const res = await toggleOverviewStatus({
                service_recovery_ids: ids,
                action: tab?.value === "Active" ? "R" : "A",
            }).unwrap();
            if (res?.response_code == 200) {
                toast.success(res?.response_msg);
                refetch();
                dispatch(clearSelectedRowsData(true));
            } else {
                toast.error(res?.response_msg);
            }
        } catch (err) {
            toast.error("Updation failed");
        }
    };
    const [getDestination, setGetDestination] = useState([]);
    const fetchDestination = async () => {
        try {
            const res = await withRFSToken.post(GETDESTINATION, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.port_code,
                        label: item.port_code,
                    })) : [];
                    setGetDestination(transformedData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    useEffect(() => {
        if (isMounted.current) return;
        fetchDestination();
        isMounted.current = true;
      }, []);
     const filtersConfig = [
    { type: "multiselect", field: "status_type", placeholder: "Status", class: 'dw-14',
      options: dropData?.tracking_status?.map((item) => ({
            label: item.label,
            value: item.value,
        })) || [],
    },
    { type: "multiselect", field: "station", placeholder: "Station", class: 'dw-14',
      options: getDestination?.map((item) => ({
        label: item.label,
        value: item.value,
      })) || [],
    },
    { type: "multiselect", field: "dis_type", placeholder: "Irregularity", class: 'dw-14',
       options: dropData?.irregularity_type?.map((item) => ({
            label: item.label,
            value: item.label,
        })) || [],
    },
  ];

    const bulkActions = tab?.value === "Active"
        ? [{ label: "Archive", action: handleArchive, icon: ArchiveIcon }]
        : tab?.value === "Archived"
            ? [{ label: "Activate", action: handleArchive, icon: ArchiveIcon }]
            : [];

    const columns = [
        {
            label: "", field: "actions", enableSearch: false, cls: 'single_action', cls: 'tw-5',
            renderCell: (row) => (<div className="">
                <EyeIcon className="row_view" style={{ cursor: "pointer" }}
                    onClick={(e) => {
                        e.stopPropagation();
                        fetchFSU(row)
                    }}
                />
            </div>),
        },
        { label: "Status", field: "status_type", enableSearch: true, cls: "tw-10" },
        { label: "Station", field: "station", enableSearch: true, cls: "tw-8" },
        {
            label: "Flight No.", field: "flight_no", enableSearch: true, cls: "tw-8",
            renderCell: (row) => {
                const prefix = row?.flight_prefix || "";
                const number = row?.flight_no || "";
                if (!prefix && !number) return "";
                return prefix && number ? `${prefix}-${number}` : `${prefix}${number}`;
            },
        },
        { label: "Total Pieces", field: "total_pieces_awb", enableSearch: true, cls: "tw-8" },
        { label: "Total Weight", field: "total_weight_awb", enableSearch: true, cls: "tw-8" },
        { label: "Actual Pieces", field: "total_actual_pieces_awb", enableSearch: true, cls: "tw-8" },
        { label: "Actual Weight", field: "total_actual_weight_awb", enableSearch: true, cls: "tw-8" },
        { label: "Irregularity", field: "dis_type", enableSearch: true, cls: "tw-8" },
        { label: "DIS Info", field: "dis_info", enableSearch: true, cls: "tw-8" },
        { label: "Updated On", field: "created_at", enableSearch: true,
            renderCell: (row) => {
                const timestamp = getTodayDateTime(row?.created_at, 'DMY');
                return timestamp ? timestamp : "";
            },
         },
    ];

    const modalClose = () => setShowModal(false)

    return (
        <>
        {console.log("dropdata : ", dropData)}
         <div className="d-flex justify-content-between align-items-center mb-2">
            <TableFilters filtersConfig={filtersConfig} />
        </div>
        <div>
            <TableGrid
                columns={columns}
                rows={myData?.Rows}
                checkboxSelection={false}
                totalRecords={myData?.TotalRows || 0}
                onClickRow={(row) => {
                    console.log("Clicked Row:", row);
                }}
                loading={isFetching}
                // rowKey="service_recovery_id"
            // bulkActions={bulkActions}
            />
        </div>
        <CommonModal
            show={showModal}
            // onHide={handleModalClose}
            onHide={modalClose}
            title='FSU Message Details'
            // subTitle={modalPos?.subTitle}
            className='modal_bgw primary_modal modal_width_551'
            footer={<></>}
        >
                <div>
                    <div className='fsu_text_box '>
                    <h4> {modalData?.status_type} ({propData?.master_airway_bill_prefix + '-' + propData?.master_airway_bill_no}) - {modalData?.station} </h4>
                    <Row className='mb-2'>
                        <Col md={4}> 
                        <label>Total Pieces</label>
                        <p>{modalData?.total_pieces_awb}</p>
                        </Col>
                        <Col md={4}> 
                        <label>Total Weight</label>
                        <p>{modalData?.total_weight_awb}</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={4}> 
                        <label>Actual Pieces</label>
                        <p>{modalData?.total_actual_pieces_awb}</p>
                        </Col>
                        <Col md={4}> 
                        <label>Actual Weight</label>
                        <p>{modalData?.total_actual_weight_awb}</p>
                        </Col>
                    </Row>
                    {/* <div>Total Pieces {modalData?.total_pieces_awb}</div>
                    <div>Total Weight {modalData?.total_weight_awb}</div>
                    <div>Actual Pieces {modalData?.total_actual_pieces_awb}</div>
                    <div>Actual Weight {modalData?.total_actual_weight_awb}</div> */}

                    </div>

                    <hr/>
                   
                    {modalData?.raw_fsu?.length > 0 ?
                        <div className='max-hgt-55'>
                            {modalData?.raw_fsu?.map((fsu, index) => (
                                <div className='fsu_box' key={fsu?.id + '_' + index}>
                                    <h4>{fsu?.fsu_date?.slice(0, 16)}</h4>
                                    <p dangerouslySetInnerHTML={{
                                        __html: (fsu?.raw_fsu_inbox?.message_data || 'No content available')
                                            .replace(/[\u0000-\u0008\u000B\u000C\u000E-\u001F]/g, '')
                                            .replace(/\r\n/g, '<br />')
                                            .trim()
                                    }}>
                                    </p>
                                </div>
                            ))}
                        </div>
                        : <></>
                    }
                </div>
            </CommonModal>
        </>
    );
};

export default Tracking;